export const TYPE = "type";
export const SIZE = "size";
export const COLOUR = "colour";
export const COLOUR_TAGS = "colourTags";
export const CATEGORY = "category";
export const SORT = "sort";
export const PRICE_ASC = "Price: low to high";
export const PRICE_DESC = "Price: high to low";
export const DISCOUNT = "Discount";
export const FEATURED = "Featured";
export const STANDARD_SIZES = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "O/S", "L/XL", "S/M"];
export const DRESS_SIZES = ["00", "0", "2", "4", "6", "8", "10", "12", "14", "16", "18"];
export const SHOE_SIZES = ["35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47"];
export const BEDDING_SIZES = ["Double", "Double/Queen", "Queen", "King"];
export const PANT_SIZES = [
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "28/30",
  "29/30",
  "30/30",
  "31/30",
  "32/30",
  "33/30",
  "34/30",
  "35/30",
  "36/30",
  "38/30",
  "40/30",
  "42/30",
  "28/32",
  "29/32",
  "30/32",
  "32/32",
  "34/32",
  "36/32",
  "38/32",
  "40/32",
  "42/32",
];
export const COLORS_MAP = {
  'black': '#000000',
  'white': '#FFFFFF',
  'alabaster': '#bada55',
}